import { render, staticRenderFns } from "./PointOverviewList.vue?vue&type=template&id=35be4810&"
import script from "./PointOverviewList.vue?vue&type=script&lang=js&"
export * from "./PointOverviewList.vue?vue&type=script&lang=js&"
import style0 from "./PointOverviewList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports